// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__6LgzL","errorLogs":"EditorFooter_errorLogs__1AJJf"};